export type AnalyticsQueryParams = {
    from: string;
    to: string;
    propertyLabels?: string[];
};

export const queryKeys = {
    activities: 'activities',
    amiIncomeLimits: 'amiIncomeLimits',
    analyticsFunnel: 'analyticsFunnel',
    analyticsProperties: 'analyticsProperties',
    analyticsConversations: 'analyticsConversations',
    analyticsTours: 'analyticsTours',
    analyticsApplications: 'analyticsApplications',
    analyticsTeamPerformance: 'analyticsTeamPerformance',
    analyticsLeads: 'analyticsLeads',
    applications: 'applications',
    billingInfo: 'billingInfo',
    billingStatus: 'billingStatus',
    calendarIntegrations: 'calendarIntegrations',
    contacts: 'contacts',
    conversationsList: 'conversationsList',
    currentPlan: 'currentPlan',
    conversations: 'conversations',
    facebookIntegration: 'facebookIntegration',
    ringCentralIntegration: 'ringCentralIntegration',
    rentManagerIntegration: 'rentManagerIntegration',
    googleRedirectUrl: 'googleRedirectUrl',
    groups: 'groups',
    leads: 'leads',
    leadStageHistory: 'lead-stage-history',
    leadIngestionMethods: 'leadIngestionMethods',
    leadLabels: 'leadLabels',
    leadRoutingRules: 'leadRoutingRules',
    leadSources: 'leadSources',
    loggedInUser: 'loggedInUser',
    loggedInUserWithIngestEmailUsage: 'loggedInUserWithIngestEmailUsage',
    messages: 'messages',
    notifications: 'notifications',
    onboardingConfig: 'onboardingConfig',
    onboardingInvitation: 'onboardingInvitation',
    onboardingInvites: 'onboardingInvites',
    outlookRedirectUrl: 'outlookRedirectUrl',
    playbooks: 'playbooks',
    teamPlaybooks: 'teamPlaybooks',
    paymentMethods: 'paymentMethods',
    payments: 'payments',
    playbooksV2: 'playbooksV2',
    playbookTextTemplateVariables: 'playbookTextTemplateVariables',
    properties: 'properties',
    touringHours: 'touringHours',
    propertyLabels: 'propertyLabels',
    showings: 'showings',
    replySuggestions: 'replySuggestions',
    factSuggestions: 'factSuggestions',
    leadFacts: 'leadFacts',
    stripeClientSecret: 'stripeClientSecret',
    teamMembers: 'teamMembers',
    teamSettings: 'teamSettings',
    userStreaks: 'userStreaks',
    leadAttachments: 'leadAttachments',
    snippets: 'snippets',
    achievements: 'achievements',
    inboxes: 'inboxes',
    inboxFavorites: 'inboxFavoritesFavorites',
    orgTeams: 'orgTeams',
    listings: 'listings',
};
